module.exports = __webpack_public_path__ + "static/assets/a502038712150aea43bcc851aab57fbc.png";